var playLottie = function playLottie(container) {
  if (!container) return;
  var path = container.dataset.path;
  var anime = lottie.loadAnimation({
    container: container,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: path,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  });
};
export default playLottie;